/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {
  APPLICATION_STATUS_CATEGORY,
  APPLICATION_STATUS_CONTACT,
  APPLICATION_STATUS_DESCRIPTION,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_SUMMARY,
} from "./applicationStatus";
import React from "react";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import progressBarSteps from "./progressBarSteps.ts";
import Categories from "../../components/Form/FamilyLaw/Death/Categories";
import Summary from "../../components/Form/FamilyLaw/Death/Summary";
import PersonalTextMessage from "../../components/Form/Common/PersonalTextMessage/PersonalTextMessage";
import Insurance from "../../components/Form/Common/Insurance/Insurance";
import Documents from "../../components/Form/Common/Documents/Documents";
import Personal from "../../components/Form/Common/Personal/Personal";
import { FormSteps } from "../../types/FormServiceBase";
import SummaryHintBox from "../../components/Form/Common/SummaryHintBox";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_CATEGORY]: {
    title: "Antrag - Kategorie | Legalbird",
    stepUrl: "kategorie",
    applicationStatus: APPLICATION_STATUS_CATEGORY,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"category"} progress={8} />
        <Categories {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DESCRIPTION]: {
    title: "Antrag - Angaben zum Todesfall | Legalbird",
    stepUrl: "angaben-zum-todesfall",
    applicationStatus: APPLICATION_STATUS_DESCRIPTION,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"description"} progress={28} />
        <PersonalTextMessage {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    title: "Antrag - Dokumente | Legalbird",
    applicationStatus: APPLICATION_STATUS_DOCUMENTS,
    stepUrl: "unterlagen",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"documents"} progress={50} />
        <Documents {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTACT]: {
    title: "Antrag - Kontaktdaten | Legalbird",
    stepUrl: "kontaktdaten",
    applicationStatus: APPLICATION_STATUS_CONTACT,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"personal"} progress={68} />
        <Personal {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INSURANCE]: {
    title: "Antrag - Versicherung | Legalbird",
    applicationStatus: APPLICATION_STATUS_INSURANCE,
    stepUrl: "versicherung",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"insurance"} progress={88} />
        <Insurance {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: {
    title: "Antrag - Überprüfen | Legalbird",
    stepUrl: "ueberpruefen",
    applicationStatus: APPLICATION_STATUS_SUMMARY,
    render: (props) => (
      <>
        <SummaryHintBox />
        <Summary {...props} />
      </>
    ),
  },
};

export default formSteps;
